/*
  Obsequio por llaveros — Itera
  Tienda: mayoristasfloripondia.myshopify.com · tema vivo «Nueva colección agosto» #165578244316
  24-sep-2026 primera versión · 28-sep-2026 ventana con elección · 29-sep-2026 con un solo
  obsequio lo suma solo y avisa, sin pedir clic

  Qué hace: cuenta las unidades de /collections/llaveros que hay en el carrito. Por cada 10,
  la clienta se lleva un obsequio. Si la colección de obsequios tiene un solo producto, el
  script lo suma al carrito y le avisa; si tiene varios, le pregunta cuál quiere. Si baja del
  umbral, el obsequio se retira solo.

  Los obsequios se manejan desde el admin: lo que esté en la colección `obsequios-llaveros`
  es lo que se ofrece. Esa misma colección va en «El cliente obtiene» del descuento
  automático, y así las dos mitades no se pueden desincronizar.
  Mientras la colección esté vacía, se usan los tres productos de prueba de REGALOS_DE_PRUEBA.

  INTERRUPTOR: ACTIVO está en true desde el 5 de octubre de 2026. La promo corre para todas
  las clientas. Para apagarla, poner false acá y volver a subir el archivo; apagar el
  descuento en el admin no basta, porque el obsequio seguiría entrando al carrito y la red de
  seguridad lo retiraría después de habérselo prometido a la clienta.
*/
(() => {
  'use strict';

  const ACTIVO = true;
  const COLECCION = 'llaveros';
  const UMBRAL = 10;
  const COLECCION_REGALOS = 'obsequios-llaveros';
  const REGALOS_DE_PRUEBA = [
    'extension-plateada-cadena-565494pl-7',
    'hebilla-pearls-acero-hairpers-5',
    'earcuff-hojas-doradas-567575-12',
  ];
  const MAX_REGALOS = 10;
  const PROPIEDAD = '_regalo_llaveros';
  const CACHE = 'flp_ids_llaveros';

  const fetchNativo = window.fetch.bind(window);
  let trabajando = false;
  let descartado = false;
  let catalogoCache = null;

  function encendido() {
    try {
      const parametro = new URL(window.location.href).searchParams.get('regalo-test');
      // localStorage y no sessionStorage: así el interruptor sobrevive a una pestaña nueva
      if (parametro === '1') localStorage.setItem('flp_regalo_test', '1');
      if (parametro === '0') localStorage.removeItem('flp_regalo_test');
      return ACTIVO || localStorage.getItem('flp_regalo_test') === '1';
    } catch (error) {
      return ACTIVO;
    }
  }

  const pesos = (centavos) =>
    new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 })
      .format(centavos / 100);

  async function pedir(url, cuerpo) {
    const respuesta = await fetchNativo(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    });
    if (!respuesta.ok) throw new Error(url + ' respondió ' + respuesta.status + ': ' + (await respuesta.text()));
    return respuesta.json();
  }

  const leerCarrito = () => fetchNativo('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const pedirJson = (url) =>
    fetchNativo(url, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null);

  async function idsDeLaColeccion() {
    try {
      const guardado = JSON.parse(sessionStorage.getItem(CACHE) || 'null');
      if (guardado && Date.now() - guardado.momento < 3600000) return new Set(guardado.ids);
    } catch (error) { /* sin caché, se vuelve a pedir */ }

    const ids = [];
    for (let pagina = 1; pagina <= 4; pagina += 1) {
      const datos = await pedirJson('/collections/' + COLECCION + '/products.json?limit=250&page=' + pagina);
      if (!datos) break;
      datos.products.forEach((producto) => ids.push(producto.id));
      if (datos.products.length < 250) break;
    }
    if (!ids.length) throw new Error('la colección ' + COLECCION + ' no devolvió productos');
    try {
      sessionStorage.setItem(CACHE, JSON.stringify({ momento: Date.now(), ids: ids }));
    } catch (error) { /* modo privado */ }
    return new Set(ids);
  }

  async function catalogo() {
    if (catalogoCache) return catalogoCache;

    const coleccion = await pedirJson('/collections/' + COLECCION_REGALOS + '/products.json?limit=250');
    let lista = ((coleccion && coleccion.products) || [])
      .filter((producto) => producto.variants && producto.variants.length)
      .map((producto) => ({
        titulo: producto.title,
        variante: producto.variants[0].id,
        centavos: Math.round(parseFloat(producto.variants[0].price) * 100),
        imagen: producto.images && producto.images[0] ? producto.images[0].src : '',
        disponible: producto.variants[0].available !== false,
      }));

    // Los productos de prueba solo existen mientras la promo está apagada. Con ACTIVO en true
    // y la colección vacía, el script no ofrece nada: antes caía en los de prueba y le habría
    // ofrecido a las clientas tres productos que el descuento no cubre. Cerrado el 5-oct-2026,
    // el día que el obsequio desapareció del catálogo y la colección quedó en cero.
    if (!lista.length && !ACTIVO) {
      const sueltos = await Promise.all(REGALOS_DE_PRUEBA.map((handle) => pedirJson('/products/' + handle + '.js')));
      lista = sueltos.filter(Boolean).map((producto) => ({
        titulo: producto.title,
        variante: producto.variants[0].id,
        centavos: producto.price,
        imagen: producto.featured_image || '',
        disponible: producto.available !== false,
      }));
    }

    catalogoCache = lista.filter((regalo) => regalo.disponible);
    if (!catalogoCache.length) {
      console.warn(
        '[obsequio llaveros] la colección «' + COLECCION_REGALOS + '» no tiene ningún producto ' +
        'disponible, así que no hay nada que regalar. Revisa que el obsequio esté publicado, ' +
        'con stock y dentro de esa colección.'
      );
    }
    return catalogoCache;
  }

  function estadoDelCarrito(carrito, idsLlaveros) {
    const lineasRegalo = carrito.items.filter((item) => item.properties && item.properties[PROPIEDAD]);
    const unidades = carrito.items
      .filter((item) => lineasRegalo.indexOf(item) === -1 && idsLlaveros.has(item.product_id))
      .reduce((total, item) => total + item.quantity, 0);
    const ganados = Math.min(Math.floor(unidades / UMBRAL), MAX_REGALOS);
    const elegidos = lineasRegalo.reduce((total, item) => total + item.quantity, 0);
    return { lineasRegalo, unidades, ganados, elegidos };
  }

  /* ---------- la ventana ---------- */

  const ESTILOS = `
    .flp-rg-fondo{position:fixed;inset:0;background:rgba(35,35,35,.55);z-index:2147483000;
      display:flex;align-items:center;justify-content:center;padding:16px;}
    .flp-rg-caja{background:#F9F3EA;color:#232323;border-radius:14px;max-width:460px;width:100%;
      max-height:86vh;overflow-y:auto;padding:26px 22px 22px;position:relative;
      font-family:'Poppins',system-ui,-apple-system,sans-serif;box-shadow:0 8px 30px rgba(35,35,35,.18);}
    .flp-rg-cerrar{position:absolute;top:12px;right:12px;background:none;border:0;font-size:26px;
      line-height:1;color:#232323;cursor:pointer;padding:4px 8px;opacity:.6;}
    .flp-rg-cerrar:hover{opacity:1;}
    .flp-rg-titulo{margin:0 0 6px;font-size:21px;font-weight:600;letter-spacing:.01em;}
    .flp-rg-bajada{margin:0 0 18px;font-size:14px;line-height:1.45;color:#5b5b5b;}
    .flp-rg-lista{list-style:none;margin:0;padding:0;display:grid;gap:10px;}
    .flp-rg-item{display:flex;align-items:center;gap:13px;background:#fff;border:1px solid #F4BFB3;
      border-radius:10px;padding:11px 13px;}
    .flp-rg-foto{width:58px;height:58px;object-fit:cover;border-radius:8px;background:#F8F8F8;flex:0 0 58px;}
    .flp-rg-datos{flex:1;min-width:0;}
    .flp-rg-nombre{font-size:14px;font-weight:600;margin:0 0 3px;line-height:1.3;}
    .flp-rg-precio{font-size:13px;color:#A68649;}
    .flp-rg-precio s{color:#9a9a9a;margin-right:6px;}
    .flp-rg-boton{background:#EF85A4;color:#fff;border:0;border-radius:999px;padding:9px 17px;
      font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;font-family:inherit;}
    .flp-rg-boton:hover{background:#e06f91;}
    .flp-rg-boton[disabled]{opacity:.55;cursor:default;}
    @media (max-width:420px){
      .flp-rg-item{flex-wrap:wrap;}
      .flp-rg-boton{width:100%;}
    }
    .flp-rg-aviso{position:fixed;left:14px;top:50%;transform:translateY(-50%);z-index:2147482000;
      background:#232323;color:#fff;border-radius:999px;padding:7px 13px;font-size:11px;
      font-family:'Poppins',system-ui,sans-serif;letter-spacing:.02em;cursor:pointer;
      box-shadow:0 3px 12px rgba(0,0,0,.25);opacity:.85;}
    .flp-rg-aviso:hover{opacity:1;}
  `;

  function asegurarEstilos() {
    if (document.getElementById('flp-rg-estilos')) return;
    const nodo = document.createElement('style');
    nodo.id = 'flp-rg-estilos';
    nodo.textContent = ESTILOS;
    document.head.appendChild(nodo);
  }

  function cerrarModal(porElUsuario) {
    const fondo = document.getElementById('flp-rg-fondo');
    if (fondo) fondo.remove();
    if (porElUsuario) descartado = true;
  }

  async function abrirModal(pendientes) {
    const regalos = await catalogo();
    if (!regalos.length) return;
    cerrarModal(false);
    asegurarEstilos();

    const fondo = document.createElement('div');
    fondo.className = 'flp-rg-fondo';
    fondo.id = 'flp-rg-fondo';
    fondo.setAttribute('role', 'dialog');
    fondo.setAttribute('aria-modal', 'true');
    fondo.setAttribute('aria-label', 'Escoge tu obsequio');

    const caja = document.createElement('div');
    caja.className = 'flp-rg-caja';

    const titulo = pendientes > 1 ? 'Tienes ' + pendientes + ' obsequios' : 'Tienes un obsequio';
    const bajada = pendientes > 1
      ? 'Por cada 10 llaveros te llevas uno. Escoge el primero y lo sumamos a tu pedido.'
      : 'Llegaste a los 10 llaveros. Escoge cuál quieres y lo sumamos a tu pedido.';

    caja.innerHTML =
      '<button class="flp-rg-cerrar" aria-label="Cerrar">&times;</button>' +
      '<h2 class="flp-rg-titulo"></h2>' +
      '<p class="flp-rg-bajada"></p>' +
      '<ul class="flp-rg-lista"></ul>';
    caja.querySelector('.flp-rg-titulo').textContent = titulo;
    caja.querySelector('.flp-rg-bajada').textContent = bajada;

    const lista = caja.querySelector('.flp-rg-lista');
    regalos.forEach((regalo) => {
      const item = document.createElement('li');
      item.className = 'flp-rg-item';
      const foto = document.createElement('img');
      foto.className = 'flp-rg-foto';
      foto.loading = 'lazy';
      foto.alt = '';
      foto.src = regalo.imagen || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      const datos = document.createElement('div');
      datos.className = 'flp-rg-datos';
      const nombre = document.createElement('p');
      nombre.className = 'flp-rg-nombre';
      nombre.textContent = regalo.titulo;
      const precio = document.createElement('p');
      precio.className = 'flp-rg-precio';
      precio.innerHTML = '<s></s>Regalo';
      precio.querySelector('s').textContent = pesos(regalo.centavos);
      const boton = document.createElement('button');
      boton.className = 'flp-rg-boton';
      boton.type = 'button';
      boton.textContent = 'Lo quiero';
      boton.addEventListener('click', () => {
        caja.querySelectorAll('.flp-rg-boton').forEach((b) => { b.disabled = true; });
        boton.textContent = 'Agregando…';
        elegir(regalo.variante);
      });
      datos.appendChild(nombre);
      datos.appendChild(precio);
      item.appendChild(foto);
      item.appendChild(datos);
      item.appendChild(boton);
      lista.appendChild(item);
    });

    caja.querySelector('.flp-rg-cerrar').addEventListener('click', () => cerrarModal(true));
    fondo.addEventListener('click', (evento) => { if (evento.target === fondo) cerrarModal(true); });
    document.addEventListener('keydown', function alEscapar(evento) {
      if (evento.key === 'Escape') { cerrarModal(true); document.removeEventListener('keydown', alEscapar); }
    });

    fondo.appendChild(caja);
    document.body.appendChild(fondo);
  }

  async function abrirAviso(regalo, cantidad) {
    cerrarModal(false);
    asegurarEstilos();

    const fondo = document.createElement('div');
    fondo.className = 'flp-rg-fondo';
    fondo.id = 'flp-rg-fondo';
    fondo.setAttribute('role', 'dialog');
    fondo.setAttribute('aria-modal', 'true');
    fondo.setAttribute('aria-label', 'Obsequio agregado');

    const caja = document.createElement('div');
    caja.className = 'flp-rg-caja';
    caja.innerHTML =
      '<button class="flp-rg-cerrar" aria-label="Cerrar">&times;</button>' +
      '<h2 class="flp-rg-titulo"></h2>' +
      '<p class="flp-rg-bajada"></p>' +
      '<ul class="flp-rg-lista"></ul>';
    caja.querySelector('.flp-rg-titulo').textContent =
      cantidad > 1 ? '\u00a1TE LLEVAS ' + cantidad + ' REGALOS!' : '\u00a1TE LLEVAS UN REGALO!';
    const bajada = caja.querySelector('.flp-rg-bajada');
    bajada.textContent = 'Por cada 10 llaveros, recibe GRATIS un Llavero edici\u00f3n limitada.';
    bajada.appendChild(document.createElement('br'));
    bajada.appendChild(document.createTextNode(
      cantidad > 1 ? 'Ya est\u00e1n sumados a tu pedido, sin costo.' : 'Ya est\u00e1 sumado a tu pedido, sin costo.'
    ));

    const item = document.createElement('li');
    item.className = 'flp-rg-item';
    const foto = document.createElement('img');
    foto.className = 'flp-rg-foto';
    foto.loading = 'lazy';
    foto.alt = '';
    foto.src = regalo.imagen || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    const datos = document.createElement('div');
    datos.className = 'flp-rg-datos';
    const nombre = document.createElement('p');
    nombre.className = 'flp-rg-nombre';
    nombre.textContent = cantidad > 1 ? regalo.titulo + ' x' + cantidad : regalo.titulo;
    const precio = document.createElement('p');
    precio.className = 'flp-rg-precio';
    precio.innerHTML = '<s></s>Regalo';
    precio.querySelector('s').textContent = pesos(regalo.centavos * cantidad);
    const boton = document.createElement('button');
    boton.className = 'flp-rg-boton';
    boton.type = 'button';
    boton.textContent = 'Listo';
    boton.addEventListener('click', () => cerrarModal(true));
    datos.appendChild(nombre);
    datos.appendChild(precio);
    item.appendChild(foto);
    item.appendChild(datos);
    item.appendChild(boton);
    caja.querySelector('.flp-rg-lista').appendChild(item);

    caja.querySelector('.flp-rg-cerrar').addEventListener('click', () => cerrarModal(true));
    fondo.addEventListener('click', (evento) => { if (evento.target === fondo) cerrarModal(true); });
    document.addEventListener('keydown', function alEscapar(evento) {
      if (evento.key === 'Escape') { cerrarModal(true); document.removeEventListener('keydown', alEscapar); }
    });

    fondo.appendChild(caja);
    document.body.appendChild(fondo);
  }

  /* ---------- el motor ---------- */

  async function repintar() {
    try {
      const secciones = await pedirJson('/?sections=mini_cart');
      const destino = document.getElementById('shopify-section-mini_cart');
      const fresco = secciones && new DOMParser()
        .parseFromString(secciones.mini_cart || '', 'text/html')
        .getElementById('shopify-section-mini_cart');
      if (destino && fresco) destino.innerHTML = fresco.innerHTML;

      const carrito = await leerCarrito();
      document.querySelectorAll('[data-cart-count]').forEach((nodo) => {
        nodo.textContent = carrito.item_count;
      });
    } catch (error) {
      console.warn('[obsequio llaveros] no se pudo repintar el carrito', error);
    }
    if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }

  /*
    Red de seguridad. Un obsequio que el descuento no deja en cero es un cobro que la
    clienta no pidió, así que se retira. Pasa si alguien mete un producto a la colección de
    obsequios y olvida que el descuento automático apunte a esa misma colección.
  */
  async function retirarLoQueSeCobra() {
    const carrito = await leerCarrito();
    const cobrados = carrito.items.filter(
      (item) => item.properties && item.properties[PROPIEDAD] && item.final_line_price > 0
    );
    for (const linea of cobrados) {
      await pedir('/cart/change.js', { id: linea.key, quantity: 0 });
      console.warn(
        '[obsequio llaveros] retirado «' + linea.title + '»: el descuento no lo dejó en cero. ' +
        'Revisa que el producto esté dentro de la colección que usa el descuento automático.'
      );
    }
    return cobrados.length > 0;
  }

  async function elegir(variante) {
    if (trabajando) return;
    trabajando = true;
    let sinCubrir = false;
    try {
      await pedir('/cart/add.js', {
        items: [{ id: variante, quantity: 1, properties: { [PROPIEDAD]: 'si' } }],
      });
      sinCubrir = await retirarLoQueSeCobra();
    } catch (error) {
      console.warn('[obsequio llaveros] no se pudo agregar el obsequio', error);
    } finally {
      trabajando = false;
    }
    cerrarModal(false);
    if (sinCubrir) descartado = false; // vuelve a ofrecer, para que escoja otro
    await sincronizar();
    await repintar();
  }

  async function sincronizar() {
    if (!encendido() || trabajando) return;
    trabajando = true;
    let cambio = false;
    let aviso = null;
    try {
      const carrito = await leerCarrito();
      const llaveros = await idsDeLaColeccion();
      const s = estadoDelCarrito(carrito, llaveros);

      let sobran = s.elegidos - s.ganados;
      for (let i = s.lineasRegalo.length - 1; i >= 0 && sobran > 0; i -= 1) {
        const linea = s.lineasRegalo[i];
        const quitar = Math.min(sobran, linea.quantity);
        await pedir('/cart/change.js', { id: linea.key, quantity: linea.quantity - quitar });
        sobran -= quitar;
        cambio = true;
      }

      const pendientes = Math.max(0, s.ganados - Math.min(s.elegidos, s.ganados));
      if (pendientes === 0) {
        cerrarModal(false);
      } else {
        const regalos = await catalogo();
        if (regalos.length === 1) {
          // Un solo obsequio: no hay nada que escoger, se suma y se avisa.
          await pedir('/cart/add.js', {
            items: [{ id: regalos[0].variante, quantity: pendientes, properties: { [PROPIEDAD]: 'si' } }],
          });
          cambio = true;
          if (!(await retirarLoQueSeCobra())) aviso = { regalo: regalos[0], cantidad: pendientes };
        } else if (regalos.length > 1 && !descartado) {
          await abrirModal(pendientes);
        }
      }
    } catch (error) {
      console.warn('[obsequio llaveros]', error);
    } finally {
      trabajando = false;
    }
    if (aviso && !descartado) await abrirAviso(aviso.regalo, aviso.cantidad);
    if (cambio) await repintar();
  }

  const esRutaDeCarrito = (url) => /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url || ''));
  const programar = () => { descartado = false; window.setTimeout(sincronizar, 150); };

  window.fetch = function (recurso) {
    const url = recurso && recurso.url ? recurso.url : recurso;
    const promesa = fetchNativo.apply(this, arguments);
    if (esRutaDeCarrito(url)) promesa.then(programar).catch(() => {});
    return promesa;
  };

  const abrirOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    if (esRutaDeCarrito(url)) this.addEventListener('load', programar);
    return abrirOriginal.apply(this, arguments);
  };

  /*
    Señal visible del estado. Sin esto no hay forma de saber desde fuera si el montaje está
    encendido, y un «no funciona» se confunde con «está apagado». Pasó tres veces.
  */
  function marcarModoPrueba() {
    if (ACTIVO || !encendido()) {
      if (!ACTIVO) {
        console.info(
          '[obsequio llaveros] apagado. Para probarlo, abre esta misma página con ?regalo-test=1'
        );
      }
      return;
    }
    if (document.getElementById('flp-rg-aviso')) return;
    asegurarEstilos();
    const aviso = document.createElement('div');
    aviso.id = 'flp-rg-aviso';
    aviso.className = 'flp-rg-aviso';
    aviso.title = 'Solo tú lo ves. Clic para apagarlo.';
    aviso.textContent = 'obsequio · modo prueba';
    aviso.addEventListener('click', () => {
      try { localStorage.removeItem('flp_regalo_test'); } catch (error) { /* modo privado */ }
      aviso.remove();
      cerrarModal(false);
    });
    document.body.appendChild(aviso);
  }

  function arrancar() {
    marcarModoPrueba();
    sincronizar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
